<ng-container *ngIf="isLoggedIn">
    <pddj-header></pddj-header>
</ng-container>
<router-outlet></router-outlet>
<ng-container *ngIf="isLoggedIn">
    <app-footer></app-footer>
</ng-container>
